import { CommonModule } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-generic-tooltip',
  templateUrl: './generic-tooltip.component.html',
  styleUrls: ['./generic-tooltip.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class GenericTooltipComponent {

  readonly tooltip = input<any>();
  left!: number;
  top!: number;
  readonly position = input<string>('');
  readonly anchorPos = input<string>('');
  childTemplate: TemplateRef<any> | any;
  isStringInput: boolean = false;


}
